import { IPageTabNavLink } from "../interfaces-and-types";

import transactionIcon from "../assets/icons/transaction-minus.svg";
import listPadIcon from "../assets/icons/list-pad.svg";
import noteIcon from "../assets/icons/note.svg";
import linkColoredIcon from "../assets/icons/link-colored.svg";
import recurringIcon from "../assets/icons/recurring.svg";
import convertCardIcon from "../assets/icons/convert-card.svg";
import feedbackIcon from "../assets/icons/qmark.svg";

interface IMainTabNavLink extends IPageTabNavLink {
  icon?: string;
  isShowMore: boolean;
}

export const mainNavLinks: IMainTabNavLink[] = [
  {
    name: "Home",
    route: "/",
    isShowMore: false,
  },
  {
    name: "Payments",
    route: "/payments",
    isShowMore: false,
  },
  {
    name: "Balances",
    route: "/balances",
    isShowMore: false,
  },
  // {
  //   name: "Reports",
  //   route: "/reports",
  //   isShowMore: false,
  // },
  {
    name: "Customers",
    route: "/customers",
    isShowMore: false,
  },
  {
    name: "Products",
    route: "/products",
    isShowMore: false,
  },
  {
    name: "Transfers",
    route: "/transfers",
    // icon: transactionIcon,
    isShowMore: false,
  },
  // {
  //   name: "Invoices",
  //   route: "/payments/invoices",
  //   icon: listPadIcon,
  //   isShowMore: true,
  // },
  // {
  //   name: "Frauds & Risks",
  //   route: "/payments/frauds",
  //   icon: noteIcon,
  //   isShowMore: true,
  // },
  {
    name: "Payment Links",
    route: "/payments/payment-links",
    icon: linkColoredIcon,
    isShowMore: true,
  },
  // {
  //   name: "Subscriptions",
  //   route: "/payments/subscriptions",
  //   icon: recurringIcon,
  //   isShowMore: true,
  // },
  // {
  //   name: "Disputes",
  //   route: "/disputes",
  //   icon: convertCardIcon,
  //   isShowMore: true,
  // },
  // {
  //   name: "Feedback",
  //   route: "/feedback",
  //   icon: feedbackIcon,
  //   isShowMore: true,
  // },
];
